import { Route } from '@angular/router';

import { LoginComponent, MainComponent, StandardPageComponent } from './components';
import { provideTrendImportMonitorMock } from './sys-monitor/trend-import-monitor/trend-import-monitor.mock';

const loadDashboard = () => import('./dashboard/dashboard.component').then((mod) => mod.DashboardComponent);
export const appRoutes: Route[] = [
  {
    path: 'album',
    loadChildren: () => import('./album/routes').then((mod) => mod.routes),
  },
  {
    path: 'product',
    loadChildren: () => import('./product/routes').then((mod) => mod.routes),
  },
  {
    path: 'track',
    loadChildren: () => import('./track/routes').then((mod) => mod.routes),
    data: { type: 'track' },
  },
  {
    path: 'page/password-reset/:id',
    loadComponent: () =>
      import('./components/password-reset/password-reset.component').then((mod) => mod.PasswordResetComponent),
  },
  {
    path: 'page/error',
    loadComponent: () =>
      import('./components/http-error-page/http-error-page.component').then((mod) => mod.HttpErrorPageComponent),
  },
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: '',
        component: StandardPageComponent,
        children: [
          {
            path: 'user',
            loadChildren: () => import('./user/user-routes').then((mod) => mod.userRoutes),
          },
          {
            path: 'dashboard',
            loadComponent: loadDashboard,
            title: 'dashboard',
          },
          {
            path: 'notification-center',
            loadComponent: () =>
              import('./notification-center/list/notification-center-list.component').then(
                (mod) => mod.NotificationCenterListComponent,
              ),
          },

          {
            path: 'page/faqs',
            loadChildren: () => import('./faq/faq-routes').then((mod) => mod.faqRoutes),
          },
          {
            path: 'faqs',
            loadChildren: () => import('./faq/faq-routes').then((mod) => mod.faqRoutes),
          },
          {
            path: 'home',
            redirectTo: 'dashboard',
          },
          {
            path: 'youtube',
            loadChildren: () => import('./youtube/routes').then((mod) => mod.routes),
          },
          {
            path: 'distribution-network',
            loadComponent: () =>
              import('./distribution-network/distribution-network.component').then(
                (mod) => mod.DistributionNetworkComponent,
              ),
          },
          {
            path: 'sys/trend-import-monitor',
            loadComponent: () =>
              import('./sys-monitor/trend-import-monitor/trend-import-monitor.component').then(
                (mod) => mod.TrendImportMonitorComponent,
              ),
            // TODO: remove the mock once GET /api/v1/sys/monitor/trend-imports exists in the backend
            providers: [provideTrendImportMonitorMock()],
          },
          {
            path: 'login',
            component: LoginComponent,
          },
          {
            path: 'wave-validator-test',
            loadComponent: () =>
              import('./wave-validator/wave-validator.component').then((mod) => mod.WaveValidatorComponent),
          },
          {
            path: '',
            pathMatch: 'full',
            loadComponent: loadDashboard,
            title: 'dashboard',
          },
          {
            path: 'product-new/wizard',
            loadComponent: () =>
              import('./product/wizard/product-wizard.component').then((mod) => mod.ProductWizardComponent),
            title: 'music.product.wizard',
          },
          {
            path: 'product-new/wizard-help',
            redirectTo: 'product-new/wizard-help/sessions',
            pathMatch: 'full',
          },
          {
            path: 'product-new/wizard-help/:id',
            loadComponent: () =>
              import('./product/wizard/wizard-help/wizard-help.component').then((mod) => mod.WizardHelpComponent),
            title: 'music.product.wizard-help',
          },
        ],
      },
      {
        path: 'page',
        loadChildren: () => import('./iframe/iframe-routes').then((mod) => mod.iframeRoutes),
      },

      {
        path: '**',
        redirectTo: 'dashboard',
      },
    ],
  },
];
